import { apiClient } from "@/shared/api/client";

export interface ChessNewsItem {
  title: string;
  url: string;
}

export const fetchChessNews = () => apiClient<{ items: ChessNewsItem[] }>("/news/chess");
